import { render } from "./PolicySection.vue?vue&type=template&id=1061135d&scoped=true"
import script from "./PolicySection.vue?vue&type=script&lang=js"
export * from "./PolicySection.vue?vue&type=script&lang=js"

import "./PolicySection.vue?vue&type=style&index=0&id=1061135d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1061135d"]])

export default __exports__